import React from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FiTrash2 } from "react-icons/fi";
import { createPortal } from "react-dom";

const DeleteSeriveModal = ({
  itemName,
  onConfirm,
  onClose,
  loading = false,
}) => {
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return createPortal(
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4"
      onClick={handleBackdropClick}
    >
      <div className="relative  w-full max-w-sm sm:max-w-md bg-white rounded-xl shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="bg-red-400 flex items-center justify-between  p-3 m-auto">
          <h2 className="text-black text-xl font-semibold">
            Delete Confirmation
          </h2>
          <button onClick={onClose} aria-label="Close" disabled={loading}>
            <AiOutlineClose className="text-black w-5 h-5 hover:opacity-80 transition" />
          </button>
        </div>

        {/* Body */}
        <div className="p-6 flex flex-col items-center text-center gap-4">
          <FiTrash2 className="w-12 h-12 text-red-600 bg-red-100 rounded-full p-2 shadow-sm" />
          <p className="text-gray-700 text-sm sm:text-base font-medium">
            Are you sure you want to delete{" "}
            <span className="text-red-600 font-semibold">{itemName}</span>? This
            action cannot be undone.
          </p>
        </div>

        {/* Footer */}
        <div className="flex justify-between gap-4 px-6 pb-6">
          <button
            onClick={onClose}
            disabled={loading}
            className={'flex-1 py-2 text-black text-sm sm:text-base rounded-lg border border-gray-300 bg-white  transition'}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={loading}
            className={'flex-1 py-2 text-sm sm:text-base rounded-lg bg-gradient-to-r bg-red-400  text-white transition shadow-md'}
          >
            {loading ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default DeleteSeriveModal;